import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../Button';
import ZoomInfoToolTip from '../ZoomInfoTooltip';
import styles from './ResetButton.module.css';
const ResetButton = ({ customText, onClick, disabled, displayInfoTooltip }) => (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx(Button, Object.assign({ className: styles.resetZoomButton, size: 'small', roundedCorners: true, onClick: onClick, disabled: disabled }, { children: customText || 'Reset' }), void 0), displayInfoTooltip && _jsx(ZoomInfoToolTip, {}, void 0)] }), void 0));
export default ResetButton;
